import React from 'react';
import {DoppeTemplateInstance} from "../../doppe-sdk/doppe-template/doppe-template";
import {DoppeActionView} from "../../doppe-sdk/doppe-action-button-template/doppe-action-button-template";
import {useDoppeViewerClientServices} from "../../client/doppe-user-app/doppe-viewer-client-services";
import {WixAppRuntimeEnvironment} from "@wix/devzai-common-wix";
import {evaluateFunction} from "@wix/devzai-utils-common";

export const DoppeTemplateBasedActionView = React.memo(function DoppeTemplateBasedActionView (props: DoppeTemplateBasedActionView.Props) {
    const {
        actionViewTemplate,
        ...contextProps
    } = props;

    const clientServices = useDoppeViewerClientServices();
    const doppeTemplatesStore = clientServices.bymoTemplatesStore;

    const templateData = doppeTemplatesStore.getActionButtonTemplateData(actionViewTemplate.templateId);

    return React.createElement(templateData.componentType, {
        templateProps: {
            ...templateData.initialValues,
            ...actionViewTemplate.templateProps,
        },
        enableAnimation: evaluateFunction(() => {
            switch (clientServices.doppeUserAppData.appRuntimeEnvironment) {
                case WixAppRuntimeEnvironment.Local:
                case WixAppRuntimeEnvironment.Staging: {
                    return true;
                }
                default: {
                    return false;
                }
            }
        }),

        ...contextProps
    })
});

export namespace DoppeTemplateBasedActionView {

    export interface Props extends DoppeActionView.ContextProps  {
        actionViewTemplate: DoppeTemplateInstance;
    }
}
